(ns arthur.clock.element
  "The clock on an `<audio>` element. The original backend, kept switchable.

  Reads `currentTime` and takes it as the position. That is the whole of it, and
  it is why this backend needs a WAV: an element holds a URL, so a mixdown has
  to be encoded and blobbed before it can be played — see `audio/mix`'s
  `clock!`. The encode is O(the clip's length) and runs on the main thread, so a
  long take costs seconds of frozen UI on open, on every tab switch and on every
  edit to a track. `arthur.clock.graph` exists to not do that.

  What this backend still has that the graph one has to be told: the OS media
  keys and the media session, which the element gets from the browser for free.

  KEPT so the two can be compared on the same document rather than swapped on
  faith. When the graph backend has been trusted for a while, this namespace and
  `mix/clock!`'s WAV packaging go together."
  (:require [arthur.clock.transport :as t]))

(deftype Element [^js el]
  t/Transport
  (-position [_] (.-currentTime el))
  (-duration [_] (.-duration el))
  (-playing? [_] (and (not (.-paused el)) (not (.-ended el))))
  (-rate [_] (.-playbackRate el))
  (-set-rate! [_ r] (set! (.-playbackRate el) r))
  (-play! [_]
    ;; Returns a promise that rejects if the browser has not seen a gesture yet.
    ;; Swallowed: the transport button IS the gesture, so this can only fire on a
    ;; programmatic play, where a console error is noise rather than news.
    (some-> (.play el) (.catch (fn [_]))))
  (-pause! [_] (.pause el))
  (-seek! [_ seconds] (set! (.-currentTime el) seconds))
  (-set-loop! [_ on?] (set! (.-loop el) (boolean on?)))
  (-set-muted! [_ on?] (set! (.-muted el) (boolean on?)))
  (-release! [_]
    ;; Nothing. React owns the element and unmounting it is what stops it; this
    ;; backend is a few property accesses wrapped in a type and holds no more
    ;; than that.
    nil))

(defn backend
  "Wrap an audio element — or anything that answers the same five properties,
  which is what `clock-test`'s fake is."
  [el]
  (->Element el))
